require('angular');
module.exports = angular.module('ModalsData',[])
.constant('modals_data',[
    {
        modal_id: 'barwy-nieba-1',
        title: '1. Barwy nieba z dużej wysokości',
        thumbnail: 'img/ilustracje/barwy-nieba-2-thumb.jpg',
        images: [
            {
                image: 'img/ilustracje/barwy-nieba-2-1100x576.jpg',
                description: ['Taki widok widziałeś już wielokrotnie w okienku samolotu. Czy zwróciłeś jednak uwagę na barwę nieba? Jest nieporównanie ciemniejsze niż to, które widzimy z powierzchni Ziemi. Jeśli spojrzysz wysoko, a nie poziomo, jak na zdjęciu, to tam jest ono już ciemnogranatowe.']
            },
            {
                image: 'img/ilustracje/barwy-nieba-2a-1100x620.jpg',
                description: [ 'Oglądane z wysokości 30 km, jaką osiągają niektóre balony, jest ono jeszcze ciemniejsze – już prawie czarne, jak na zdjęciu poniżej (źródło: <a href="http://jwastronomy.com/Stratos">jwastronomy.com/Stratos</a>). Film: <a href="https://youtube.com/watch?v=KnxvS9XFJnE">youtube.com/watch?v=KnxvS9XFJnE</a>, przedstawia podróż do granic kosmosu zrealizowaną przez amatorów. Pomysł, jego wykonanie i rezultat:  film – z którego pochodzi zdjęcie – budzą zazdrość.']
            }
        ]
    },
    {
        modal_id: 'barwy-nieba-3',
        title: '2. Barwy nieba z powierzchni Ziemi',
        thumbnail: 'img/ilustracje/barwy-nieba-3-thumb.jpg',
        images: [
            {
                image: 'img/ilustracje/barwy-nieba-3.jpg',
                description: ['Takie barwy ma niebo oglądane w pogodny dzień z powierzchni Ziemi: blado-błękitne (niemal białe) w pobliżu horyzontu, ciemnoniebieskie w zenicie.']
            }
        ]
    },
    {
        modal_id: 'wielkosc-widnokregu',
        title: '3. Wielkość widnokręgu',
        thumbnail: 'img/ilustracje/wielkosc-widnokregu-thumb.jpg',
        images: [
            {
                image: 'img/ilustracje/wielkosc-widnokregu-1100x325.jpg',
                description: ['Wielkość powierzchni Ziemi, którą widzimy, zależy od wysokości, z której patrzymy. Gdy wysokość jest znikoma w stosunku do promienia Ziemi, widziany fragment powierzchni Ziemi można uznać za płaski.']
            }
        ]
    },
    {
        modal_id: 'na-pomoc-wyobrazni-1',
        title: '4. Na pomoc wyobraźni – globus i dysk CD',
        thumbnail: 'img/ilustracje/na-pomoc-wyobrazni-1-thumb.jpg',
        images: [
            {
                image: 'img/ilustracje/na-pomoc-wyobrazni-1.jpg',
                description: ['Dyskietkę przyklejoną do globusa w miejscu, w którym przebywamy, można traktować jak przedłużenie fragmentu powierzchni Ziemi, który widzimy. Jest ona zarazem fragmentem płaszczyzny horyzontu – nieskończonej płaszczyzny stycznej do Ziemi w miejscu obserwacji. Użycie takiego prostego zestawu, lub choćby tylko jego wyobrażenie, pozwala zrozumieć wpływ obecności Ziemi pod naszymi stopami i jej ruchu na to, co widzimy ponad głową.']
            }
        ]
    },
    {
        modal_id: 'na-pomoc-wyobrazni-2',
        title: '5. Na pomoc wyobraźni – listewka i kartonik',
        thumbnail: 'img/ilustracje/na-pomoc-wyobrazni-2-thumb.jpg',
        images: [
            {
                image: 'img/ilustracje/na-pomoc-wyobrazni-2-1095x547.jpg',
                description: ['Tak prymitywny zestaw: listewka spełniająca rolę osi obrotu Ziemi, tekturka wyobrażająca płaszczyznę horyzontu i długa nitka wskazująca kierunek do obiektu, pozwala doskonale zaprezentować sytuację ziemskiego obserwatora nieba i ruchu bardzo dalekich obiektów. Pozwala zrozumieć zależność toru ruchu obiektów względem horyzontu od kierunku, w którym je widzimy.']
            }
        ]
    },
    {
        modal_id: 'poludnik-niebieski',
        title: '6. Południk niebieski',
        thumbnail: 'img/ilustracje/poludnik-niebieski-thumb.jpg',
        images: [
            {
                image: 'img/ilustracje/poludnik-niebieski-1097x928.jpg',
                description: ['Płaszczyzna przechodząca przez środek Ziemi i miejsce obserwacji jest, zgodnie z definicją geografów, płaszczyzną południka miejscowego. Jej przedłużenie (wyróżnione na rysunku żółtym kolorem) astronomowie nazwali południkiem niebieskim. W płaszczyźnie południka miejscowego i niebieskiego jest położona oś obrotu Ziemi i sfery nieba. Szczególne znaczenie tej płaszczyzny polega na tym, że poruszające się na skutek obrotu Ziemi odległe pozaziemskie obiekty, przechodząc przez tę płaszczyznę, osiągają największą lub najmniejszą wysokość ponad horyzontem. ']
            }
        ]
    },
    {
        modal_id: 'sezonowe-zmiany-nieba',
        title: '7. Sezonowe zmiany nieba',
        thumbnail: 'img/ilustracje/sezonowe-zmiany-nieba-thumb.jpg',
        images: [
            { 
                image: 'img/ilustracje/sezonowe-zmiany-nieba-1097x1097.jpg',
                description: ['Widok na położenie obserwatora znajdującego się w pobliżu równika, o północy, na początku września i w końcu października. Słońce jest poza rysunkiem, na dole. Kolorem niebieskim, zielonym i pomarańczowym są zaznaczone kierunki do trzech gwiazd położonych w płaszczyźnie rysunku. Wcześniej (z prawej strony), o północy, w pobliżu zenitu znajdowała się gwiazda, którą wskazuje linia niebieska. Po upływie około miesiąca, o północy, w okolicach zenitu będzie widoczna gwiazda wskazywana linią zieloną. Jeszcze później (po około dwóch tygodniach) będzie tam widoczna gwiazda, w stronę której jest skierowana linia pomarańczowa.']
            }
        ]
    },
    {
        modal_id: 'orbita-ziemi',
        title: '8. Orbita Ziemi jako kalendarz',
        thumbnail: 'img/ilustracje/orbita-ziemi-thumb.jpg',
        images: [
            {
                image: 'img/ilustracje/orbita-ziemi-1095x1061-p.jpg',
                description: [
                    'Widok z kierunku prostopadłego do płaszczyzny orbity Ziemi objaśniający przyczyny występowania pór roku. Gwiazdy widoczne w tle znajdują się daleko poza orbitą Ziemi i przypominają o konkretnej, ściśle określonej orientacji osi obrotu Ziemi względem gwiazd.', 
                    'Przyczyną pór roku jest stały kierunek osi obrotu Ziemi względem gwiazd, jej nachylenie do płaszczyzny orbity oraz wokółsłoneczny ruch Ziemi. Skutkiem tych okoliczności są ciągłe zmiany kąta pomiędzy kierunkiem osi obrotu Ziemi i kierunkiem do Słońca powodujące zmiany nasłonecznienia każdego miejsca Ziemi. Zwróć uwagę na fakt, iż każdemu momentowi roku odpowiada ściśle określone położenie Ziemi na orbicie. Zastanów się, czy coś by się zmieniło w stosunku do obecnego stanu, gdyby Ziemia obiegała Słońce w przeciwną stronę niż teraz?'
                ]
            }
        ]
    },
    {
        modal_id: 'lato-i-zima',
        title: '9. Lato i Zima',
        thumbnail: 'img/ilustracje/lato-i-zima-thumb.jpg',
        images: [
            { 
                image: 'img/ilustracje/lato-i-zima-1197x598.jpg',
                description: [
                    'Widok na Ziemię około 21 czerwca i 21 grudnia z kierunku prostopadłego do prostej łączącej te położenia Ziemi. Słońce znajduje się w środku, pomiędzy obiema częściami rysunku. 21 czerwca w południe każdy mieszkaniec północnej półkuli Ziemi zaobserwuje największą w ciągu roku wysokość Słońca (jest początek lata), mieszkaniec półkuli południowej zaś najmniejszą (początek zimy). 21 grudnia sytuacja jest odwrotna.',
                    'W wyróżnionych miejscach Ziemi jest narysowane położenie horyzontu w momencie południa i podana jest wysokość Słońca ponad nim. Kąt nachylenia osi obrotu Ziemi do płaszczyzny orbity określa graniczne szerokości geograficzne tych obszarów Ziemi, w których Słonce może być widoczne w zenicie (granice tego obszaru stanowią tzw. zwrotniki), oraz tych obszarów, w których występują doby bez wschodu Słońca lub doby, podczas których Słońce nie zachodzi (granice tego obszaru stanowią tzw. koła podbiegunowe). Rysunek ujawnia też przyczynę różnic długości trwania dnia w zależności od daty i miejsca na Ziemi.'    
                ]
            }
        ]
        
    },
    {
        modal_id: 'wiosna-i-jesien',
        title: '10. Wiosna i Jesień',
        thumbnail: 'img/ilustracje/wiosna-i-jesien-thumb.jpg',
        images: [
            {
                image: 'img/ilustracje/wiosna-i-jesien-1095x547.jpg',
                description: [
                    'Widok na Ziemię w dniach równonocy (około 21 IX i 21 III), z kierunku prostopadłego do prostej łączącej te położenia Ziemi. Słońce znajduje się pomiędzy oboma rysunkami. Dla obu dat, w południe, w każdym miejscu na Ziemi wysokości Słońca ponad horyzontem są takie same. Widać też, że w obu przypadkach (dla obu dat) w każdym miejscu Ziemi długość dnia jest równa długości nocy.'
                ]
            }
        ]
    },
    {
        modal_id: 'rozmiary-obrazow-gwiazd',
        title: '11. Rozmiary obrazów gwiazd',
        thumbnail: 'img/ilustracje/rozmiary-obrazow-gwiazd-thumb.jpg',
        images: [
            {
                image: 'img/ilustracje/rozmiary-obrazow-gwiazd-1100x719.jpg',
                description: [
                    'Wszystkie gwiazdy (poza Słońcem) są tak odległe, że nie możemy widzieć ich tarcz, więc wszystkie powinniśmy widzieć jako punkty. Punktami powinny również być ich obrazy rejestrowane na zdjęciach. Dlaczego więc obrazy gwiazd mają różną wielkość?'
                ]
            }
        ]
    },
    {
        modal_id: 'mglawica-leb-konia',
        title: '12. Mgławica Łeb Konia',
        thumbnail: 'img/ilustracje/mglawica-leb-konia-thumb.jpg',
        images: [
            {
                image: 'img/ilustracje/mglawica-leb-konia-1100x1082.jpg',
                description: [
                    'Zdjęcie mgławicy Łeb Konia wykonane w Australian Astronomical Obserwatory. Obraz dzieli, niemal na połowy, wertykalnie rozciągnięta, pofałdowana powierzchnia wielkiego gęstego obłoku, znajdującego się po lewej stronie. Gęstość gazu zewnętrznych części obłoku (z prawej strony) jest niewielka, jest on zjonizowany przez światło gwiazdy położonej po prawej stronie obłoku (poza zdjęciem). Gaz ten świeci i jest zarazem przejrzysty dla światła gwiazd położonych znacznie dalej. Wyraźnie widać różnicę pomiędzy liczbą gwiazd widocznych na tle obłoku (po lewej stronie zdjęcia) i obok niego, po prawej stronie zdjęcia. Swoją nazwę mgławica zawdzięcza bliższemu nam, wysuniętemu fragmentowi gęstego obłoku, widocznemu na tle bardziej odległego, świecącego gazu. Więcej <i class="fa fa-book" aria-hidden="true"></i>58, <a href="https://www.nasa.gov/multimedia/imagegallery/image_feature_2493.html"><i class="fa fa-television" aria-hidden="true"></i>98</a>.'
                ]
            }
        ]
    },
    {
        modal_id: 'wielka-mglawica-w-orionie',
        title: '13. Wielka Mgławica w Orionie – M42',
        thumbnail: 'img/ilustracje/wielka-mglawica-w-orionie-thumb.jpg',
        images: [
            {
                image: 'img/ilustracje/wielka-mglawica-w-orionie-1095x1432.jpg',
                description: [
                    'Niżej gwiazdozbiór Oriona z zaznaczonym położeniem najbardziej znanych obiektów widocznych w tym obszarze nieba. Wyżej zdjęcie mgławicy M42. W najjaśniejszym, tu niemal białym fragmencie tej mgławicy znajduje się grupa kilkudziesięciu bardzo młodych gwiazd (tzw. asocjacja), które powstały z gazu mgławicy. Gaz macierzystego obłoku jest pobudzany do świecenia promieniowaniem tych gwiazd. Cztery najjaśniejsze gwiazdy z tej grupy, położone blisko siebie, tworzą tzw. Trapez Oriona (tu są one widoczne jako jasna plamka). Zróżnicowanie barwne różnych fragmentów mgławicy jest wynikiem zróżnicowanego stopnia wzbudzania atomów gazu i obecności w obłoku atomów różnych pierwiastków. Więcej <i class="fa fa-book" aria-hidden="true"></i>60.'
                ]
            }
        ]
    },
    {
        modal_id: 'oblok-ciemnej-materii',
        title: '14. Obłok ciemnej materii "Worek węgla"',
        thumbnail: 'img/ilustracje/oblok-ciemnej-materii-thumb.jpg',
        images: [
            {
                image: 'img/ilustracje/oblok-ciemnej-materii-1100x1099.jpg',
                description: [
                    'Obłok ciemnej materii w gwiazdozbiorze Wężownika (Bernard 68). Brak gwiazd na jego tle wskazuje, że obłok ten jest względnie gęsty i znajduje się dość blisko. Więcej <i class="fa fa-book" aria-hidden="true"></i>57.'
                ]
            }
        ]
    },
    {
        modal_id: 'przestrzenny-rozklad-galatyk',
        title: '15. Przestrzenny rozkład galaktyk',
        thumbnail: 'img/ilustracje/przestrzenny-rozklad-galatyk-thumb.jpg',
        images: [
            {
                image: 'img/ilustracje/przestrzenny-rozklad-galatyk-1100x1137.jpg',
                description: [
                    'Fragment diagramu przedstawiającego rzeczywisty, przestrzenny rozkład ponad 200 tys. galaktyk, w cienkiej warstwie przestrzeni, w pobliżu równika niebieskiego. Każdy punkt na diagramie reprezentuje galaktykę. Najdalsze z nich znajdują się w odległości 2 miliardów lat świetlnych. Jest to rezultat kilku lat pracy wielu astronomów. Więcej informacji o tym programie obserwacyjnym: <a href="http://magnum.anu.edu.au/~TDFgg/"><i class="fa fa-television" aria-hidden="true"></i>99</a> '
                ]
            }
        ]
    },
    {
        modal_id: 'deep-field',
        title: '16. Deep Field',
        thumbnail: 'img/ilustracje/deep-field-thumb.jpg',
        images:[
            {
                image: 'img/ilustracje/deep-field-1100x1077.jpg',
                description: [
                    'To jedno z najbardziej niezwykłych zdjęć astronomicznych a zarazem najbardziej kosztownych. Wymagało kilkudziesięciu godzin pracy teleskopu Hubble’a. Powstało ze złożenia wielu osobnych kadrów. Obejmuje maleńki fragment nieba w gwiazdozbiorze Wielkiego Wozu – fragment, jaki przesłoniłoby drobniutkie ziarenko piasku (o średnicy 1/3 mm) trzymane w wyciągniętej ręce. Widać na nim tylko cztery gwiazdy z naszej Galaktyki (te, które są otoczone promykami). Wszystkie pozostałe obiekty – a jest ich około 3 tys. – są niesłychanie odległymi galaktykami. Odległość wielu z nich przekracza 5 miliardów lat światła; widzimy je więc takimi, jakimi były wtedy, gdy Słońce i Ziemia jeszcze nie istniały. Są pośród nich galaktyki eliptyczne, spiralne (jak nasza), soczewkowe i nieregularne. Zdjęcie to pozwala wyobrazić sobie, jak wyglądałoby nocne niebo, gdyby Układ Słoneczny znajdował się poza naszą Galaktyką, a nasze oczy zapewniły taką samą czułość na światło, jaką uzyskano na tym zdjęciu. Więcej <i class="fa fa-book" aria-hidden="true"></i>64.'
                ]
            }
        ]
        
    },
    {
        modal_id: 'wielka-mglawica-andromedy',
        title: '17. Wielka Mgławica Andromedy – M31',
        thumbnail: 'img/ilustracje/wielka-mglawica-andromedy-thumb.jpg',
        images: [
            {
                image: 'img/ilustracje/wielka-mglawica-andromedy-1095x1095.jpg',
                description: [
                    'Na mapce obejmującej duży fragment nieba (u góry) pokazane jest położenie galaktyki M31. Dla wszystkich, którzy chcieliby zobaczy ją na własne oczy, potrzebne będą zapewne dodatkowe wskazówki <i class="fa fa-certificate" aria-hidden="true"></i>90. Piękne zdjęcie tej galaktyki (widoczne niżej) wykonał Robert Gendler (<a href="http://www.robgendlerastropics.com/M31Page.html"><i class="fa fa-television" aria-hidden="true"></i>100</a>). Wielka Mgławica Andromedy jest galaktyką, rekordzistką pod względem rozmiarów kątowych. Kątowe rozmiary widocznej na zdjęciu błękitnej elipsy dysku sięgają 200 minut łuku (siedem tarcz Słońca bądź Księżyca).',
                    'Przyglądając się temu lub innym zdjęciom tej galaktyki, należy pamiętać o tym, że wszystkie widoczne na nich obiekty punktowe są gwiazdami należącymi do naszej Galaktyki. Błękitna mgła na obrzeżach dysku, a kremowa w centrum to zsumowane światło miliardów gwiazd, których z odległości ponad 2 milionów lat świetlnych nie sposób zobaczyć jako osobne punkty. Różnica barw centralnej części dysku i obszarów peryferyjnych jest przejawem różnicy pomiędzy średnią temperaturą powierzchni, a zarazem średnim wiekiem, gwiazd zasiedlających te rejony galaktyki. W centralnych obszarach procesy gwiazdotwórcze rozpoczęły się wcześniej, więc dominują tam gwiazdy stare o niższej temperaturze powierzchni – żółto-pomarańczowe <i class="fa fa-book" aria-hidden="true"></i>51. W zewnętrznych częściach dysku dominują gwiazdy młode o gorących powierzchniach – biało-błękitne. Uwagę zwracają również ciemne poszarpane sznury układające się koncentrycznie wokół jądra galaktyki. To obłoki materii międzygwiazdowej. Teraz to właśnie tam, w ich wnętrzach, zachodzą intensywne procesy gwiazdotwórcze. Więcej <i class="fa fa-book" aria-hidden="true"></i>65.'
                ]
            }
        ]
    },
    {
        modal_id: 'eagle-nebula',
        title: '18. "Eagle Nebula" (M16), "Pillars of Creation"',
        thumbnail: 'img/ilustracje/eagle-nebula-thumb.jpg',
        images:[
            {
                image: 'img/ilustracje/eagle-nebula-1099x4468.jpg',
                description: [
                    'Poniżej mapki nieba widoczne jest zdjęcie mgławicy Eagle Nebula (M16), wykonane w Australian Astronomical Obserwatory. Swoją widoczność zawdzięcza ona pobliskiej gromadzie gwiazd, widocznych na jej tle. Jest to grupa około 460 bardzo młodych (około miliona lat), masywnych (około 80 mas Słońca) i bardzo gorących gwiazd. Temperatura ich powierzchni sięga kilkudziesięciu tysięcy stopni. Moc świecenia niektórych spośród nich jest blisko milion razy większa od mocy świecenia Słońca. Światło gwiazd tej gromady pobudza do świecenia gaz zewnętrznych części wielkiego obłoku materii międzygwiazdowej. Na obrzeżach ciemnych, wydłużonych struktur widocznych w centrum mgławicy (ich długość sięga 10 lat świetlnych) utworzonych przez gęste, nieprzenikliwe dla świata, fragmenty większego obłoku (pokazanych w powiększeniu na środkowym zdjęciu ), nazywanych „Pillars of Creation”, trwają właśnie procesy formowania się nowych gwiazd. Procesy te zachodzą w niewielkich wrzecionowatych strukturach wskazanych strzałkami na najniższym zdjęciu. Rozmiary tych struktur znacznie przekraczają rozmiary Układu Słonecznego. Mgławica M16 jest odległa o około 7000 lat świetlnych.'
                ]
            }
        ]
    },
    {
        modal_id: 'plejady',
        title: '19. Plejady',
        thumbnail: 'img/ilustracje/plejady-thumb.jpg',
        images: [
            {
                image: 'img/ilustracje/plejady-1100x739.jpg',
                description: [
                    'Plejady to grupka kilkunastu jasnych, blisko siebie położonych gwiazd. Zwraca na nią uwagę każdy, kto choć przez chwilę zatrzyma wzrok na jesienno-zimowym niebie. Zajmują one obszar nieba porównywalny z rozmiarami tarczy Księżyca. Plejady są gromadą gwiazd, a dokładniej: otwartą gromadą gwiazd. Mgławica towarzysząca Plejadom jest najprawdopodobniej resztką obłoku, z którego powstały gwiazdy tej gromady. Nie jest jednak wykluczone, że mgławica ta nie ma genetycznego związku z gwiazdami gromady, lecz jest obłokiem mijanym przez Plejady w ich galaktycznej wędrówce. Plejady znajdują się w odległości około 400 lat świetlnych. Więcej <i class="fa fa-book" aria-hidden="true"></i>79.'
                ]
            }
        ]
    }
])
.factory('modalService',['$filter', 'modals_data', function( $filter, modals_data ) {
    var obj = {
        currentModal: null,
        setCurrentModal: function( modalID ) {
            this.currentModal = $filter('filter')( modals_data , { modal_id:modalID } )[0];
        }
    }
    return obj;
}]);


//////////////////
// WEBPACK FOOTER
// ./jssrc/modals-data-2804.js
// module id = 7
// module chunks = 0